module.exports = __webpack_public_path__ + "img/IND-A-2-IV.4f48654e.png";